import type { PropsWithChildren } from "react";
import { useModuleBEM, useStyles } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import clsx from "clsx";
import { ApacFormUiComponent, APAC_FORM_UI_NAME } from "../../types";
import defaultStyles from "./styles.module.scss";

interface FormInputContainerProps extends PlatformComponentProps {
  disabled?: boolean;
  error?: boolean;
}

export const FormInputContainer = ({
  className,
  disabled,
  error,
  children,
}: PropsWithChildren<FormInputContainerProps>): JSX.Element => {
  const styles = useStyles(
    APAC_FORM_UI_NAME,
    ApacFormUiComponent.FormInputContainer,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    ApacFormUiComponent.FormInputContainer
  );
  return (
    <div
      className={clsx(className, block, {
        [cn("error")]: error,
        [cn("disabled")]: disabled,
      })}
    >
      {children}
    </div>
  );
};
